// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".quote-col[data-v-35a0f818] {\n  min-width: 6.5em;\n}", ""]);
// Exports
module.exports = exports;
